module.exports = __webpack_public_path__ + "public/images/sports.00464993c66eddfaad4317f1f0917735.png";